export default "__VITE_ASSET__BL$lbmMX__"